import Vue from 'vue';
import VueRouter from 'vue-router';
import units from '@/api/units';
import Index from '../pages/index.vue';
import login from '../pages/login.vue';
import loginExamine from '../pages/loginExamine.vue';
import insteadTbLogin from '../pages/insteadTbLogin.vue';
import Home from '../pages/home/home.vue';
import Workbench from '../pages/workbench/workbench.vue';
import config from '@/api/common'; //公共变量

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Index,
    name: 'Index',
    meta: {
      title: '首页'
    }
  },
  {
    path: '/empty',
    component: () => import('../pages/empty.vue'),
    meta: {
      title: ''
    }
  },
  // {
  //   path: '/login',
  //   component: loginExamine,
  //   name: 'loginExamine',
  //   meta: {
  //     title: '登录'
  //   },
  // },
  // {
  //   path: '/web/login',
  //   component: login,
  //   name: 'web.login',
  //   meta: {
  //     title: '登录'
  //   },
  // },
  {
    path: '/:code?/login',
    component: login,
    name: 'login',
    meta: {
      title: '登录'
    }
  },
  {
    path: '/insteadTbLogin',
    component: insteadTbLogin,
    name: 'insteadTbLogin',
    meta: {
      title: '登录'
    }
  },
  {
    path: '/workbench',
    component: Workbench,
    name: 'workbench',
    redirect: '/workbench/index',
    component: () => import('../pages/workbench/index.vue'),
    children: [
      {
        path: '/workbench/index',
        name: 'workbench',
        component: () => import('../pages/workbench/workbench.vue'),
        meta: {
          title: '工作台',
          keepAlive: true
        }
      }
    ]
  },

  {
    path: '/home',
    component: Home,
    name: 'home',
    redirect: '/home/index',
    component: () => import('../pages/home/index.vue'),
    children: [
      {
        path: '/home/index',
        name: 'home',
        component: () => import('../pages/home/home.vue'),
        meta: {
          title: '业绩概览',
          keepAlive: true
        }
      },
      {
        path: '/home/chatMange',
        name: 'chatMange',
        component: () => import('../pages/home/chatMange.vue'),
        meta: {
          title: '消息公告'
        }
      },
      {
        path: '/home/detail',
        name: 'chatMange',
        component: () => import('../pages/home/detail.vue'),
        meta: {
          title: '消息公告详情'
        }
      }
    ]
  },
  // {
  /*********消息公告**********/

  /*********组织机构**********/
  {
    path: '/orgManage',
    component: () => import('../pages/router.vue'),
    redirect: '/orgManage/index',
    name: 'orgManage',
    meta: {
      title: '组织管理',
      keepAlive: true
    },
    children: [
      {
        path: '/orgManage/index',
        name: 'orgManage.index',
        component: () => import('../pages/orgManage/orgManage/orgManage.vue'),
        meta: {
          title: '组织架构',
          keepAlive: true
        }
      },
      {
        path: '/orgManage/salesman',
        name: 'orgManage.salesman',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '业务员管理',
          keepAlive: true
        },
        children: [
          {
            path: '/orgManage/salesmanManage',
            redirect: 'orgManage.salesmanManage',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '业务员管理'
            },
            children: [
              {
                path: '/orgManage/salesmanManage',
                name: 'orgManage.salesmanManage',
                component: () => import('../pages/orgManage/salesman/manage/salesmanManage.vue'),
                meta: {
                  keepAlive: true
                }
              },
              // 新增
              {
                path: '/orgManage/salesmanForm',
                name: 'orgManage.salesmanForm.add',
                component: () => import('../pages/orgManage/salesman/form/salesmanForm.vue'),
                meta: {
                  title: '基础信息',
                  keepAlive: true,
                  parentUrl: '/orgManage/salesmanManage'
                }
              },
              // 编辑
              {
                path: '/orgManage/salesmanForm/:userId',
                name: 'orgManage.salesmanForm.edit',
                component: () => import('../pages/orgManage/salesman/form/salesmanForm.vue'),
                meta: {
                  title: '基础信息',
                  keepAlive: true,
                  parentUrl: '/orgManage/salesmanManage'
                }
              }
            ]
          },
          {
            path: '/personnelMag/promotionManage',
            redirect: '/personnelMag/promotionManage',
            meta: {
              title: '职级维护'
            },
            component: () => import('../pages/router'),
            children: [
              {
                //机构
                path: '/personnelMag/promotionManage',
                name: 'promotionManage.mechanism',
                component: () => import('../pages/personnelMag/promotionManage/mechanism.vue'),
                meta: {
                  keepAlive: true
                }
              }
            ]
          }
        ]
      },
      {
        path: '/orgManage/visitorManage/index',
        name: 'orgManage.visitorManage.index',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '入职审核'
        },
        children: [
          {
            path: '/orgManage/inductionAudit/index',
            name: 'orgManage.inductionAudit.index',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '入职审核'
            },
            children: [
              {
                path: '/orgManage/inductionAudit',
                name: 'orgManage.inductionAudit',
                component: () => import('../pages/orgManage/inductionAudit/inductionAudit.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/orgManage/inductionAudit/audit',
                name: 'orgManage.inductionAudit.audit',
                component: () => import('../pages/orgManage/inductionAudit/auditForm.vue'),
                meta: {
                  title: '审核',
                  keepAlive: true,
                  parentUrl: '/orgManage/inductionAudit'
                }
              },
              {
                path: '/orgManage/inductionAudit/detail',
                name: 'orgManage.inductionAudit.detail',
                component: () => import('../pages/orgManage/inductionAudit/auditForm.vue'),
                meta: {
                  title: '详情',
                  parentUrl: '/orgManage/inductionAudit'
                }
              }
            ]
          },
          {
            path: '/orgManage/visitorManage/index',
            name: 'orgManage.visitorManage.index',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '游客管理'
            },
            children: [
              {
                path: '/orgManage/visitorManage',
                name: 'orgManage.visitorManage',
                component: () => import('../pages/orgManage/visitorManage/visitorManage.vue'),
                meta: {
                  keepAlive: true
                }
              },
              // 新增
              {
                path: '/orgManage/visitorManage/salesmanForm',
                name: 'orgManage.visitorManage.salesmanForm.edit',
                component: () => import('../pages/orgManage/salesman/form/salesmanForm.vue'),
                meta: {
                  title: '入职',
                  parentUrl: '/orgManage/visitorManage'
                }
              }
            ]
          }
        ]
      },
      {
        path: '/orgManage/resignationAudit',
        name: 'orgManage.resignationAudit',
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/orgManage/resignationAudit',
            name: 'orgManage.resignationAudit',
            component: () => import('../pages/orgManage/resignationAudit/resignationAudit.vue'),
            meta: {
              title: '离职审核',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/personnelMag/professional',
        meta: {
          title: '执业证管理',
          keepAlive: true
        },
        component: () => import('../pages/personnelMag/professional/index.vue')
      },
      {
        path: '/personnelMag/upWkIdManage',
        meta: {
          title: '上游工号管理',
          keepAlive: true
        },
        component: () => import('../pages/personnelMag/upWkIdManage/index.vue')
      },
      {
        path: '/personnelMag/contractManage',
        meta: {
          title: '人力合同',
          keepAlive: true
        },
        component: () => import('../pages/personnelMag/contractManage/index.vue')
      },
      {
        path: '/systemSet/house',
        name: 'systemSet.house',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '内勤管理',
          keepAlive: true
        },
        children: [
          {
            path: '/systemSet/houseStaff',
            name: 'systemSet.houseStaff',
            component: () => import('../pages/systemSet/houseStaff/manage/index'),
            meta: {
              title: '内勤人员',
              keepAlive: true
            }
          },
          // 新增
          {
            path: '/systemSet/houseStaffForm',
            name: 'systemSet.houseStaffForm.add',
            component: () => import('../pages/systemSet/houseStaff/form/houseStaffForm.vue'),
            meta: {
              title: '基础信息',
              keepAlive: true
            }
          },
          // 编辑
          {
            path: '/systemSet/houseStaffForm/:userId',
            name: 'systemSet.houseStaffForm.edit',
            component: () => import('../pages/systemSet/houseStaff/form/houseStaffForm.vue'),
            meta: {
              title: '基础信息'
            }
          }
        ]
      },
      {
        path: '/systemSet/roleManage',
        redirect: '/systemSet/roleManage',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '内勤角色',
          keepAlive: true
        },
        children: [
          {
            path: '/systemSet/roleManage',
            component: () => import('../pages/systemSet/roleManage/index'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/systemSet/roleManageAdd',
            component: () => import('../pages/systemSet/roleManage/changeRoleForm.vue'),
            meta: {
              title: '新增角色',
              keepAlive: true,
              parentUrl: '/systemSet/roleManage'
            }
          },
          {
            path: '/systemSet/roleManageAuthority',
            component: () => import('../pages/systemSet/roleManage/changeRoleForm.vue'),
            meta: {
              parentUrl: '/systemSet/roleManage',
              title: '角色权限'
            }
          }
        ]
      },
      {
        path: '/systemSet/accountNumManage',
        redirect: '/systemSet/accountNumManage',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '内勤账号',
          keepAlive: true
        },
        children: [
          {
            path: '/systemSet/accountNumManage',
            component: () => import('../pages/systemSet/accountNumManage/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/systemSet/accountNumManage/roleAuthority',
            component: () => import('../pages/systemSet/accountNumManage/roleAuthority.vue'),
            meta: {
              parentUrl: '/systemSet/accountNumManage',
              title: '角色权限'
            }
          }
        ]
      },
      {
        path: '/operate/courseRecord',
        component: () => import('../pages/contentManagement/trainingCourse/courseRecord'),
        meta: {
          title: '人员培训记录',
          keepAlive: true
        }
      }
    ]
  },

  /*********产品资源**********/
  // 商品库
  {
    path: '/productResource/',
    redirect: '/productResource/product/view',
    meta: {
      title: '产品资源'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/productResource/productPolicy',
        name: 'productPolicy',
        component: () => import('../pages/productResource/productPolicy/index.vue'),
        meta: {
          keepAlive: true,
          title: '产品结算政策'
        }
      },
      {
        path: '/productResource/product/groupProduct',
        redirect: '/productResource/product/groupProduct',
        component: () => import('../pages/router.vue'),
        meta: {
          keepAlive: true,
          title: '团财产品库'
        },
        children: [
          {
            path: '/productResource/product/groupProduct',
            name: 'groupProduct',
            component: () => import('../pages/productResource/product/groupProduct.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/productResource/product/groupInsuranceLink',
            name: 'groupInsuranceLink',
            component: () => import('../pages/productResource/product/insuranceLink.vue'),
            meta: {
              title: '查看投保链接',
              parentUrl: '/productResource/product/groupProduct'
            }
          },
          {
            path: '/productResource/product/groupPromotional',
            name: 'groupPromotional',
            component: () => import('../pages/productResource/product/promotional.vue'),
            meta: {
              title: '推广资料',
              parentUrl: '/productResource/product/groupProduct'
            }
          },
          {
            path: '/productResource/product/lookServer',
            name: 'groupProductLookServer',
            component: () => import('../pages/productResource/product/lookServer.vue'),
            meta: {
              title: '查看服务费',
              keepAlive: true,
              parentUrl: '/productResource/product/groupProduct'
            }
          }
        ]
      },
      {
        path: '/productResource/product/view',
        redirect: '/productResource/product/index',
        meta: {
          title: '商品库中心'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/productResource/product/index',
            name: 'product',
            component: () => import('../pages/productResource/product/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/productResource/product/lookServer',
            name: 'lookServer',
            component: () => import('../pages/productResource/product/lookServer.vue'),
            meta: {
              title: '查看服务费',
              keepAlive: true,
              parentUrl: '/productResource/product/index'
            }
          },
          {
            path: '/productResource/product/insuranceLink',
            name: 'insuranceLink',
            component: () => import('../pages/productResource/product/insuranceLink.vue'),
            meta: {
              title: '查看投保链接',
              parentUrl: '/productResource/product/index'
            }
          },
          {
            path: '/productResource/product/promotional',
            name: 'promotional',
            component: () => import('../pages/productResource/product/promotional.vue'),
            meta: {
              title: '推广资料',
              parentUrl: '/productResource/product/index'
            }
          }
        ]
      },
      {
        path: '/productResource/productManager',
        redirect: '/productResource/productManager',
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/productResource/productManager',
            redirect: '/productResource/productManager',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '产品库'
            },
            children: [
              {
                path: '/productResource/productManager',
                name: 'productManager.index',
                component: () => import('../pages/productResource/productManager/index.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/productResource/productManager/insuranceLink',
                name: 'productManagerInsuranceLink',
                component: () => import('../pages/productResource/product/insuranceLink.vue'),
                meta: {
                  title: '查看投保链接',
                  parentUrl: '/productResource/productManager'
                }
              },
              {
                path: '/productResource/productManager/productEdit',
                name: 'productManager.productEdit',
                meta: {
                  keepAlive: true,
                  title: '编辑产品',
                  parentUrl: '/productResource/productManager'
                },
                component: () => import('../pages/productResource/productManager/productEdit.vue')
              },
              {
                path: '/productResource/productManager/productDetail',
                name: 'productManager.productDetail',
                meta: {
                  keepAlive: true,
                  title: '产品详情',
                  parentUrl: '/productResource/productManager'
                },
                component: () => import('../pages/productResource/productManager/productDetail.vue')
              },
              {
                path: '/productResource/productManager/productAdd',
                name: 'productManager.productAdd',
                meta: {
                  keepAlive: true,
                  title: '新增产品',
                  parentUrl: '/productResource/productManager'
                },
                component: () => import('../pages/productResource/productManager/productEdit.vue')
              },
              {
                path: '/productResource/productManager/product',
                name: 'productManager.product',
                component: () => import('../pages/productResource/productManager/product.vue'),
                meta: {
                  keepAlive: true,
                  title: '产品总库导入',
                  parentUrl: '/productResource/productManager'
                }
              }
            ]
          },
          {
            path: '/productResource/feeUpstreamCofnig',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '上游费用配置'
            },
            children: [
              {
                path: '/productResource/feeUpstreamCofnig',
                meta: {
                  keepAlive: true,
                  title: ''
                },
                component: () => import('../pages/productResource/feeUpstreamCofnig/index.vue')
              },
              {
                path: '/productResource/feeUpstreamCofnig/rateHistoryList',
                name: 'rateHistoryList',
                component: () => import('../pages/productResource/feeUpstreamCofnig/rateHistoryList.vue'),
                meta: {
                  title: '查看其他版本费率',
                  keepAlive: true,
                  parentUrl: '/productResource/feeUpstreamCofnig'
                }
              },
              {
                path: '/productResource/feeUpstreamCofnig/rateHistoryDetail',
                name: 'rateHistoryDetail',
                component: () => import('../pages/productResource/feeUpstreamCofnig/rateHistoryDetail.vue'),
                meta: {
                  title: '其他版本费率详情',
                  parentUrl: '/productResource/feeUpstreamCofnig'
                }
              },
              {
                path: '/productResource/productManager/productManageCommission',
                name: 'productManager.productManageCommission',
                meta: {
                  keepAlive: true,
                  title: '上游基础费用配置',
                  parentUrl: '/productResource/feeUpstreamCofnig'
                },
                component: () => import('../pages/productResource/productManager/productManageCommission.vue')
              },
              {
                path: '/productResource/productManager/editProductManageCommissionDetail',
                name: 'productManager.editProductManageCommissionDetail',
                meta: {
                  keepAlive: true,
                  title: '费用配置详情',
                  parentUrl: '/productResource/feeUpstreamCofnig'
                },
                component: () => import('../pages/productResource/productManager/productManageCommissionDetail.vue')
              },
              {
                path: '/productResource/productManager/futureCommissionDetail',
                name: 'productManager.futureCommissionDetail',
                meta: {
                  title: '费用配置详情',
                  parentUrl: '/productResource/feeUpstreamCofnig'
                },
                component: () => import('../pages/productResource/productManager/futureCommissionDetail.vue')
              }
            ]
          }
        ]
      },
      {
        path: '/offline/insuranceManage',
        redirect: '/offline/insuranceManage/insuranceManage',
        component: () => import('../pages/offline/insuranceManage/index.vue'),
        children: [
          {
            path: '/offline/insuranceManage/insuranceManage',
            redirect: '/offline/insuranceManage/insuranceManage',
            component: () => import('../pages/offline/insuranceManage/index.vue'),
            meta: {
              title: '供应商管理',
              keepAlive: true
            },
            children: [
              {
                path: '/offline/insuranceManage/insuranceManage',
                name: 'insuranceManage',
                component: () => import('../pages/offline/insuranceManage/insuranceManage.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/offline/insuranceManage/abovePersonnel',
                name: 'abovePersonnel',
                component: () => import('../pages/offline/insuranceManage/abovePersonnel.vue'),
                meta: {
                  title: '上号人员',
                  parentUrl: '/offline/insuranceManage/insuranceManage'
                }
              }
            ]
          },
          {
            path: '/offline/insuranceManage/addInsurance',
            name: 'addInsurance',
            component: () => import('../pages/offline/insuranceManage/addInsurance.vue'),
            meta: {
              title: '添加保司'
            }
          }
        ]
      },
      {
        path: '/offline/agreementManage',
        component: () => import('../pages/offline/agreementManage/index.vue'),
        children: [
          {
            path: '/offline/agreementManage/agreementManage',
            name: 'agreementManage',
            component: () => import('../pages/offline/agreementManage/index.vue'),
            meta: {
              title: '协议管理'
            },
            children: [
              {
                path: '/offline/agreementManage/supplierAgreement',
                name: 'agreementManage',
                component: () => import('../pages/offline/agreementManage/supplier/supplier.vue'),
                meta: {
                  title: '',
                  keepAlive: true
                }
              },
              /* 保司协议 */
              {
                path: '/offline/agreementManage/supplierAgreement/form',
                name: 'agreementManageForm',
                component: () => import('../pages/offline/agreementManage/supplier/components/insuranceCompanyForm'),
                meta: {
                  title: '新增协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/formCopy',
                name: 'addSupplementform',
                component: () => import('../pages/offline/agreementManage/supplier/components/insuranceCompanyForm'),
                meta: {
                  title: '复制协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/addSupplementform',
                name: 'addSupplementform',
                component: () => import('../pages/offline/agreementManage/supplier/components/insuranceCompanyForm'),
                meta: {
                  title: '新增补充协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/formEdit',
                name: 'formEdit',
                component: () => import('../pages/offline/agreementManage/supplier/components/insuranceCompanyForm/index.vue'),
                meta: {
                  title: '编辑协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },
              /* 通道协议 */
              {
                path: '/offline/agreementManage/supplierAgreement/channelForm',
                name: 'channelForm',
                component: () => import('../pages/offline/agreementManage/supplier/components/channelForm'),
                meta: {
                  title: '新增协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/channelFormCopy',
                name: 'channelForm',
                component: () => import('../pages/offline/agreementManage/supplier/components/channelForm'),
                meta: {
                  title: '复制协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/addSupplementChannelForm',
                name: 'addSupplementChannelForm',
                component: () => import('../pages/offline/agreementManage/supplier/components/channelForm'),
                meta: {
                  title: '新增补充协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/channelFormEdit',
                name: 'channelFormEdit',
                component: () => import('../pages/offline/agreementManage/supplier/components/channelForm'),
                meta: {
                  title: '编辑协议',
                  keepAlive: true,
                  parentUrl: '/offline/agreementManage/supplierAgreement'
                }
              },

              /* 渠道分销协议 */
              {
                path: '/offline/agreementManage/channel',
                name: 'channel',
                component: () => import('../pages/offline/agreementManage/channel/index.vue'),
                meta: {
                  title: '渠道分销协议',
                  keepAlive: true
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/channelDistributionForm',
                name: 'channelDistributionForm',
                component: () => import('../pages/offline/agreementManage/channel/components/index.vue'),
                meta: {
                  title: '新增协议',
                  keepAlive: true
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/channelDistributionFormCopy',
                name: 'channelDistributionForm',
                component: () => import('../pages/offline/agreementManage/channel/components/index.vue'),
                meta: {
                  title: '复制协议',
                  keepAlive: true
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/channelDistributionFormEdit',
                name: 'channelDistributionFormEdit',
                component: () => import('../pages/offline/agreementManage/channel/components/index.vue'),
                meta: {
                  title: '编辑协议',
                  keepAlive: true
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/channelAddSupplementForm',
                name: 'addSupplementForm',
                component: () => import('../pages/offline/agreementManage/channel/components/index.vue'),
                meta: {
                  title: '新增补充协议',
                  keepAlive: true
                }
              },
              {
                path: '/offline/agreementManage/supplierAgreement/agreementSnapshot',
                name: 'agreementSnapshot',
                component: () => import('../pages/offline/agreementManage/supplier/components/agreementSnapshot.vue'),
                meta: {
                  title: '协议快照'
                }
              }
            ]
          }
        ]
      }
    ]
  },
  /*********费用管理**********/
  {
    path: '/activityManage',
    redirect: '/activityManage',
    meta: {
      title: '费用管理'
    },
    component: () => import('../pages/activityManage/index'),
    children: [
      {
        path: '/activityManage',
        redirect: '/activityManage',
        component: () => import('../pages/activityManage/index'),
        meta: {
          title: '平台活动'
        },
        children: [
          {
            path: '/activityManage',
            component: () => import('../pages/activityManage/activity/index'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/activityManage/detail',
            component: () => import('../pages/activityManage/detail/index.vue'),
            meta: {
              title: '活动管理详情',
              keepAlive: true,
              parentUrl: '/activityManage'
            }
          }
        ]
      },
      /* 基本法管理-新 */
      {
        path: '/basicLawNew',
        redirect: '/basicLawNew/config',
        meta: {
          title: '基本法管理'
        },
        component: () => import('../pages/offline/basicLawNew/index.vue'),
        children: [
          {
            path: '/basicLawNew/config',
            name: 'basicLawNewConfig',
            component: () => import('../pages/offline/basicLawNew/config/index.vue'),
            meta: {
              title: '基本法配置',
              keepAlive: true
            }
          },
          {
            path: '/basicLawNew/applyMechanism',
            name: 'applyMechanism',
            component: () => import('../pages/offline/basicLawNew/applyMechanism.vue'),
            meta: {
              title: '适用机构',
              keepAlive: true
            }
          },
          {
            path: '/basicLawNew/rankInterests',
            name: 'rankInterests',
            component: () => import('../pages/offline/basicLawNew/rankInterests.vue'),
            meta: {
              title: '职级利益'
            }
          },
          {
            path: '/basicLawNew/promote',
            name: 'promote',
            component: () => import('../pages/offline/basicLawNew/promote.vue'),
            meta: {
              title: '晋升'
            }
          },
          {
            path: '/basicLawNew/keep',
            name: 'promote',
            component: () => import('../pages/offline/basicLawNew/keep.vue'),
            meta: {
              title: '维持'
            }
          },
          {
            path: '/testManagement',
            meta: {
              title: '业务员考核管理'
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/orderManage/testManagement',
                name: 'orderManage.testManagement',
                component: () => import('../pages/orderManage/testManagement/index.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/orderManage/testManagement/riseDetail',
                name: 'testManagement.riseDetail',
                component: () => import('../pages/orderManage/testManagement/components/riseRank/riseDetail.vue'),
                meta: {
                  title: '指标详情'
                  // keepAlive: true,
                }
              },
            ]
          },
        ]
      },
      {
        path: '/productResource/fee',
        redirect: '/productResource/fee/config',
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/productResource/fee/config',
            name: 'feeConfig',
            component: () => import('../pages/productResource/fee/config.vue'),
            meta: {
              title: '下游费用配置',
              keepAlive: true
            }
          },
          {
            path: '/productResource/fee/config/templateDetail',
            name: 'configTemplateDetail',
            component: () => import('../pages/productResource/fee/templateDetail.vue'),
            meta: {
              title: '模板详情',
              keepAlive: true,
              parentUrl: '/productResource/fee/config'
            }
          },
          {
            path: '/productResource/fee/rateDetail',
            name: 'rateDetail',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '费率表'
            },
            children: [
              {
                path: '/productResource/fee/rateDetail',
                name: 'rateDetail',
                component: () => import('../pages/productResource/fee/rateDetail.vue'),
                meta: {
                  title: '费率表',
                  keepAlive: true,
                  parentUrl: '/productResource/fee/config'
                }
              },
              {
                path: '/productResource/fee/rateHistoryDetailNew',
                name: 'rateHistoryDetailNew',
                component: () => import('../pages/productResource/fee/rateHistoryDetailNew.vue'),
                meta: {
                  title: '其他版本费率详情',
                  parentUrl: '/productResource/fee/config'
                }
              }
            ]
          },
          {
            path: '/productResource/fee/rateHistoryDetail',
            name: 'rateHistoryDetail',
            component: () => import('../pages/productResource/fee/rateHistoryDetail.vue'),
            meta: {
              title: '历史费率详情'
            }
          },
          {
            path: '/productResource/fee/rateChangeRecord',
            name: 'rateChangeRecord',
            component: () => import('../pages/productResource/fee/rateChangeRecord.vue'),
            meta: {
              title: '费率变更记录',
              keepAlive: true,
              parentUrl: '/productResource/fee/config'
            }
          }
        ]
      },
      {
        path: '/productResource/feeTemplate',
        redirect: '/productResource/fee/templateList',
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/productResource/fee/templateList',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '下游费用模板'
            },
            children: [
              {
                path: '/productResource/fee/templateList',
                name: 'feeTemplateList',
                component: () => import('../pages/productResource/fee/templateList.vue'),
                meta: {
                  title: '',
                  keepAlive: true
                }
              },
              {
                path: '/productResource/fee/templateDetail',
                component: () => import('../pages/router.vue'),
                meta: {
                  title: '模板详情'
                },
                children: [
                  {
                    path: '/productResource/fee/templateDetail',
                    name: 'feeTemplateDetail',
                    component: () => import('../pages/productResource/fee/templateDetail.vue'),
                    meta: {
                      keepAlive: true,
                      parentUrl: '/productResource/fee/templateList'
                    }
                  },
                  {
                    path: '/productResource/fee/templateRateDetail',
                    component: () => import('../pages/router.vue'),
                    meta: {
                      title: '费率详情'
                    },
                    children: [
                      {
                        path: '/productResource/fee/templateRateDetail',
                        name: 'feeTemplateRateDetail',
                        component: () => import('../pages/productResource/fee/templateRateDetail.vue'),
                        meta: {
                          title: '',
                          keepAlive: true,
                          parentUrl: '/productResource/fee/templateList'
                        }
                      },
                      {
                        path: '/productResource/fee/templateHistoryDetail',
                        name: 'templateHistoryDetail',
                        component: () => import('../pages/productResource/fee/templateHistoryNew.vue'),
                        meta: {
                          title: '其他版本费率详情',
                          parentUrl: '/productResource/fee/templateList'
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/foldingLabelConfig/config',
        name: 'foldingLabelConfig_config',
        component: () => import('../pages/foldingLabelConfig/config.vue'),
        meta: {
          title: '公司折标系数',
          keepAlive: true
        }
      },
      {
        path: '/foldingLabelConfig/foldConfig',
        redirect: '/foldingLabelConfig/foldConfig',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '上游折标系数'
        },
        children: [
          {
            path: '/foldingLabelConfig/foldConfig',
            name: 'foldingLabelConfig_foldConfig',
            component: () => import('../pages/foldingLabelConfig/foldConfig.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/foldingLabelConfig/supplierFactorConfig',
            name: 'foldingLabelConfig_supplierFactorConfig',
            component: () => import('../pages/foldingLabelConfig/config.vue'),
            meta: {
              title: '供应商折标系数配置',
              parentUrl: '/foldingLabelConfig/foldConfig'
            }
          }
        ]
      }
    ]
  },

  /*********业务管理**********/
  {
    path: '/order',
    meta: {
      title: '业务管理'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/orderM',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '人身险'
        },
        children: [
          {
            path: '/orderManage',
            name: 'orderManage',
            component: () => import('../pages/orderManage/order/order.vue'),
            meta: {
              title: '人身险订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/insuredOrder/main',
            redirect: '/orderManage/insuredOrder/main',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '人身险保单'
            },
            children: [
              {
                path: '/orderManage/insuredOrder/main',
                name: 'insureOrder',
                component: () => import('../pages/orderManage/insuredOrder/main.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/orderManage/insuredOrder/addPolicy',
                name: 'insureOrder.addPolicy',
                component: () => import('../pages/orderManage/insuredOrder/addPolicy.vue'),
                meta: {
                  title: '新增保单',
                  keepAlive: true,
                  parentUrl: '/orderManage/insuredOrder/main'
                }
              },
              {
                path: '/orderManage/insuredOrder/draftList',
                name: 'insureOrder.draftList',
                component: () => import('../pages/orderManage/insuredOrder/draftList.vue'),
                meta: {
                  title: '草稿箱',
                  keepAlive: true,
                  parentUrl: '/orderManage/insuredOrder/main'
                }
              },
              {
                path: '/orderManage/insuredOrder/editPolicy/:policyNo',
                name: 'insureOrder.editPolicy',
                component: () => import('../pages/orderManage/insuredOrder/addPolicy.vue'),
                meta: {
                  title: '编辑保单',
                  keepAlive: true,
                  parentUrl: '/orderManage/insuredOrder/main'
                }
              },
              {
                path: '/orderManage/insuredOrder/copyPolicy/:policyNo',
                name: 'insureOrder.copyPolicy',
                component: () => import('../pages/orderManage/insuredOrder/addPolicy.vue'),
                meta: {
                  title: '复制保单',
                  keepAlive: true
                }
              }
            ]
          },
          {
            path: '/orderManage/visitReceived/visitReceived',
            name: 'visitReceived',
            component: () => import('../pages/orderManage/visitReceived/visitReceived.vue'),
            meta: {
              title: '回执回访管理',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/waitOrder/order',
            name: 'waitOrder',
            component: () => import('../pages/orderManage/waitOrder/order.vue'),
            meta: {
              title: '代投订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/appointmentOrder',
            name: 'appointmentOrder',
            component: () => import('../pages/orderManage/appointmentOrder/index.vue'),
            meta: {
              title: '预约投保单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/qualityTesting',
            name: 'orderManage.qualityTesting',
            component: () => import('../pages/orderManage/qualityTesting/qualityTesting.vue'),
            meta: {
              title: '质检单管理',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/orderManage/group/order',
        name: 'orderManage.group',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '团财管理'
        },
        children: [
          {
            path: '/orderManage/group/order',
            redirect: '/orderManage/group/order',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '投保订单'
            },
            children: [
              {
                path: '/orderManage/group/order',
                name: 'orderManage.group.order',
                component: () => import('../pages/orderManage/group/order/index.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/orderManage/group/order/detail',
                name: 'orderManage.group.order.detail',
                component: () => import('../pages/orderManage/group/order/detail.vue'),
                meta: {
                  title: '投保订单详情',
                  parentUrl: '/orderManage/group/order'
                }
              }
            ]
          },
          {
            path: '/orderManage/group/peservation',
            redirect: '/orderManage/group/peservation',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '保全订单'
            },
            children: [
              {
                path: '/orderManage/group/peservation',
                name: 'orderManage.group.peservation',
                component: () => import('../pages/orderManage/group/peservation/index.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/orderManage/group/peservation/detail',
                name: 'orderManage.group.peservation.detail',
                component: () => import('../pages/orderManage/group/peservation/detail'),
                meta: {
                  title: '保全订单详情',
                  keepAlive: true,
                  parentUrl: '/orderManage/group/peservation'
                }
              },
              {
                path: '/orderManage/group/peservation/policyDetail',
                name: 'orderManage.group.policyDetail',
                component: () => import('../pages/orderManage/group/policy/policyDetail.vue'),
                meta: {
                  title: '团财险保单详情',
                  parentUrl: '/orderManage/group/peservation'
                }
              }
            ]
          },
          {
            path: '/orderManage/group/policy',
            redirect: '/orderManage/group/policy',
            component: () => import('../pages/router.vue'),
            meta: {
              title: '团财保单'
            },
            children: [
              {
                path: '/orderManage/group/policy',
                name: 'orderManage.group.policy',
                component: () => import('../pages/orderManage/group/policy/index.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/orderManage/group/policyDetail',
                name: 'orderManage.group.policyDetail',
                component: () => import('../pages/orderManage/group/policy/policyDetail.vue'),
                meta: {
                  title: '团财险保单详情',
                  parentUrl: '/orderManage/group/policy'
                }
              },
              {
                path: '/orderManage/group/addGroupPolicy',
                name: 'orderManage.group.addGroupPolicy',
                component: () => import('../pages/orderManage/group/policy/addGroupPolicy.vue'),
                meta: {
                  title: '新增团财险保单',
                  keepAlive: true,
                  parentUrl: '/orderManage/group/policy'
                }
              },
              {
                path: '/orderManage/group/editGroupPolicy',
                name: 'orderManage.group.editGroupPolicy',
                component: () => import('../pages/orderManage/group/policy/addGroupPolicy.vue'),
                meta: {
                  title: '编辑团财险保单',
                  keepAlive: true,
                  parentUrl: '/orderManage/group/policy'
                }
              }
            ]
          },
          {
            path: '/orderManage/group/insuredList',
            name: 'orderManage.group.insuredList',
            component: () => import('../pages/orderManage/group/insuredList/index.vue'),
            meta: {
              title: '保单人员清单',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/orderManage/group/draftList',
        name: 'group.draftList',
        component: () => import('../pages/orderManage/group/policy/draftList.vue'),
        meta: {
          title: '草稿箱',
          keepAlive: true
        }
      },
      {
        path: '/orderManage/group/invoiceList',
        name: 'orderManage.group.invoiceList',
        component: () => import('../pages/orderManage/group/policy/invoiceList.vue'),
        meta: {
          title: '申请开票'
        }
      },
      
      {
        path: '/orderManage/zeroInsure',
        redirect: '/orderManage/zeroInsure/order/index',
        meta: {
          title: '赠险订保单'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/orderManage/zeroInsure/order/index',
            name: 'orderManage.zeroInsure.order.index',
            component: () => import('../pages/orderManage/zeroInsure/order/index.vue'),
            meta: {
              title: '赠险订单',
              keepAlive: true
            }
          },
          {
            path: '/orderManage/zeroInsure/policy/index',
            name: 'orderManage.zeroInsure.policy.index',
            component: () => import('../pages/orderManage/zeroInsure/policy/index.vue'),
            meta: {
              title: '赠险保单',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/orderManage/orderQualityCheck',
        meta: {
          title: '签单质检',
          keepAlive: true
        },
        component: () => import('../pages/orderManage/orderQualityCheck/index.vue')
      }
    ]
  },

  /*********续期管理**********/
  {
    path: '/renewalManage',
    redirect: '/renewalManage/renewManage',
    meta: {
      title: '续期管理'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/renewalManage/renewManage',
        name: 'renewManage',
        component: () => import('../pages/orderManage/renewManage/index.vue'),
        meta: {
          title: '长险续费管理',
          keepAlive: true
        }
      },
      {
        path: '/renewalManage/renewManage/detail',
        name: 'renewManageDetail',
        component: () => import('../pages/orderManage/renewManage/detail'),
        meta: {
          title: '续费管理详情'
        }
      },
      {
        path: '/renewalManage/renewalManage',
        redirect: '/renewalManage/renewalManage',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '短险续保管理'
        },
        children: [
          {
            path: '/renewalManage/renewalManage',
            component: () => import('../pages/orderManage/renewalManage/index'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/renewalManage/renewalManage/detail',
            name: 'renewalManageDetail',
            component: () => import('../pages/orderManage/renewalManage/detail'),
            meta: {
              title: '续保管理详情',
              parentUrl: '/renewalManage/renewalManage'
            }
          }
        ]
      },
      {
        path: '/renewalGroupManage',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '团财续保管理'
        },
        children: [
          {
            path: '/renewalManage/renewalGroupManage',
            component: () => import('../pages/orderManage/renewalGroupManage/index'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/renewalManage/renewalGroupManage/detail',
            name: 'renewalGroupManage.detail',
            component: () => import('../pages/orderManage/renewalGroupManage/detail'),
            meta: {
              title: '团财续保详情',
              parentUrl: '/renewalManage/renewalGroupManage'
            }
          }
        ]
      },
      {
        path: '/orderManage/renewalRatioOK',
        name: 'orderManage.renewalRatioOK',
        component: () => import('../pages/orderManage/renewalRatioOK/index.vue'),
        meta: {
          title: '个人继续率统计',
          keepAlive: true
        }
      },
      {
        path: '/orderManage/renewalRatio',
        name: 'orderManage.renewalRatio',
        component: () => import('../pages/orderManage/renewalRatio/index.vue'),
        meta: {
          title: '续期继续率统计',
          keepAlive: true
        }
      }
    ]
  },
  /*********客户管理**********/
  {
    path: '/business',
    redirect: '/customerManage/list',
    meta: {
      title: '客户管理'
    },
    component: () => import('../pages/router.vue'),
    children: [
      {
        path: '/customerManage/list',
        redirect: '/customerManage/list',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '客户管理'
        },
        children: [
          {
            path: '/customerManage/list',
            name: 'customerManage',
            component: () => import('../pages/customerManage/customer/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/customerManage/channelDetail',
            name: 'customerDetail',
            component: () => import('../pages/customerManage/customer/channelDetail.vue'),
            meta: {
              title: '客户详情',
              parentUrl: '/customerManage/list'
            }
          },
          {
            path: '/customerManage/salesmanDetail',
            name: 'customerDetail',
            component: () => import('../pages/customerManage/customer/salesmanDetail.vue'),
            meta: {
              title: '客户详情',
              parentUrl: '/customerManage/list'
            }
          }
        ]
      }
    ]
  },
  /*********财务管理**********/
  {
    path: '/financialManage',
    redirect: '/financialManage/financial',
    meta: {
      title: '财务管理'
    },
    component: () => import('../pages/financialManage/index.vue'),
    children: [
      {
        path: '/offline/getAccounts/index',
        redirect: '/offline/getAccounts/index',
        component: () => import('../pages/financialManage/index.vue'),
        meta: {
          title: '对账单'
        },
        children: [
          {
            path: '/offline/getAccounts/index',
            redirect: '/offline/getAccounts/index',
            component: () => import('../pages/financialManage/index.vue'),
            meta: {
              title: '个险对账单'
            },
            children: [
              {
                path: '/offline/getAccounts/index',
                name: 'getAccounts',
                component: () => import('../pages/offline/getAccounts/index.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/offline/getAccounts/detail',
                name: 'statementDetail',
                component: () => import('../pages/offline/getAccounts/newStatement.vue'),
                meta: {
                  title: '对账单详情',
                  keepAlive: true
                }
              }
            ]
          },
          {
            path: '/offline/reconciliationAccounts/index',
            redirect: '/offline/reconciliationAccounts/index',
            component: () => import('../pages/financialManage/index.vue'),
            meta: {
              title: '个险实收'
            },
            children: [
              {
                path: '/offline/reconciliationAccounts/index',
                name: 'reconciliationAccounts',
                component: () => import('../pages/offline/reconciliationAccounts/index.vue'),
                meta: {
                  keepAlive: true
                }
              },
              {
                path: '/offline/reconciliationAccounts/detail',
                name: 'reconciliationAccountsDetail',
                component: () => import('../pages/offline/reconciliationAccounts/detail.vue'),
                meta: {
                  title: '对账单详情',
                  parentUrl: '/offline/reconciliationAccounts/index'
                }
              }
            ]
          },
          {
            path: '/offline/getAccounts/add',
            name: 'newStatement',
            component: () => import('../pages/offline/getAccounts/newStatement.vue'),
            meta: {
              title: '新建对账单',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/offline/groupAccounts/index',
        redirect: '/offline/groupAccounts/index',
        component: () => import('../pages/financialManage/index.vue'),
        meta: {
          title: '团财对账单'
        },
        children: [
          {
            path: '/offline/groupAccounts/index',
            name: 'groupAccounts',
            component: () => import('../pages/offline/groupAccounts/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/offline/groupAccounts/add',
            name: 'newStatement',
            component: () => import('../pages/offline/groupAccounts/newStatement.vue'),
            meta: {
              title: '新建对账单',
              keepAlive: true,
              parentUrl: '/offline/groupAccounts/index'
            }
          },
          {
            path: '/offline/groupAccounts/detail',
            name: 'groupStatementDetail',
            component: () => import('../pages/offline/groupAccounts/newStatement.vue'),
            meta: {
              title: '对账单详情',
              keepAlive: true,
              parentUrl: '/offline/groupAccounts/index'
            }
          }
        ]
      },
      {
        path: '/offline/groupReconciliationAccounts/index',
        redirect: '/offline/groupReconciliationAccounts/index',
        component: () => import('../pages/financialManage/index.vue'),
        meta: {
          title: '团财实收'
        },
        children: [
          {
            path: '/offline/groupReconciliationAccounts/index',
            name: 'groupReconciliationAccounts',
            component: () => import('../pages/offline/groupReconciliationAccounts/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/offline/groupReconciliationAccounts/detail',
            name: 'groupReconciliationAccountsDetail',
            component: () => import('../pages/offline/groupReconciliationAccounts/detail.vue'),
            meta: {
              title: '对账单详情',
              parentUrl: '/offline/groupReconciliationAccounts/index'
            }
          }
        ]
      },
      {
        path: '/offline/commissionRecord/firstYearIndex',
        redirect: '/offline/commissionRecord/firstYearIndex',
        component: () => import('../pages/financialManage/index.vue'),
        meta: {
          title: '个险对账数据'
        },
        children: [
          {
            path: '/offline/commissionRecord/firstYearIndex',
            name: 'commissionRecordFirst',
            component: () => import('../pages/offline/commissionRecord/firstYearIndex.vue'),
            meta: {
              title: '首期基础费用对账数据',
              keepAlive: true
            }
          },
          {
            path: '/offline/commissionRecord/nextYear',
            name: 'commissionRecordNext',
            component: () => import('../pages/offline/commissionRecord/nextYear.vue'),
            meta: {
              title: '续期基础费用对账数据',
              keepAlive: true
            }
          },
          {
            path: '/offline/commissionRecord/gradient',
            name: 'commissionRecordGradient',
            component: () => import('../pages/offline/commissionRecord/gradient.vue'),
            meta: {
              title: '首年梯度加费对账数据',
              keepAlive: true
            }
          },
          {
            path: '/offline/commissionRecord/commissionBack',
            name: 'commissionRecordBack',
            component: () => import('../pages/offline/commissionRecord/commissionBack.vue'),
            meta: {
              title: '首年后置费用对账数据',
              keepAlive: true
            }
          },
          {
            path: '/offline/commissionRecord/continuation',
            name: 'commissionRecordContinuation',
            component: () => import('../pages/offline/commissionRecord/continuation.vue'),
            meta: {
              title: '继续率奖金对账数据',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/offline/groupReconciliation/firstYearIndex',
        redirect: '/offline/groupReconciliation/firstYearIndex',
        component: () => import('../pages/financialManage/index.vue'),
        meta: {
          title: '团财对账数据'
        },
        children: [
          // 团财
          {
            path: '/offline/groupReconciliation/firstYearIndex',
            name: 'groupReconciliationFirst',
            component: () => import('../pages/offline/groupReconciliation/firstYear.vue'),
            meta: {
              title: '首期基础费用对账数据',
              keepAlive: true
            }
          },
          {
            path: '/offline/groupReconciliation/gradient',
            name: 'groupReconciliationGradient',
            component: () => import('../pages/offline/groupReconciliation/gradient.vue'),
            meta: {
              title: '首年梯度加费对账数据',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/financialManage/salesmanWithdrawal',
        name: 'financialManage.salesmanWithdrawal',
        meta: {
          title: '业务员提现',
          keepAlive: true
        },
        component: () => import('../pages/financialManage/salesmanWithdrawal/index.vue')
      },
      {
        path: '/financialManage/settlement',
        meta: {
          title: '业务员结算'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/financialManage/salesmanWithdrawalOK',
            name: 'financialManage.salesmanWithdrawalOK',
            meta: {
              title: '发放薪酬',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/salesmanWithdrawalOK/index.vue')
          },
          {
            path: '/financialManage/riskOrderOK.main',
            name: 'financialManage.riskOrderOK.main',
            meta: {
              title: '风险单处理',
              keepAlive: true
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/financialManage/riskOrderOK',
                name: 'financialManage.riskOrderOK',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/financialManage/riskOrderOK/index.vue')
              },
              {
                path: '/financialManage/salesmanPaySettlement/detail/formRiskOrderOK',
                meta: {
                  title: '明细',
                  parentUrl: '/financialManage/riskOrderOK'
                },
                component: () => import('../pages/financialManage/salesmanPaySettlement/detail.vue')
              },
              {
                path: '/financialManage/riskOrderOK/riskOrderList',
                meta: {
                  title: '明细',
                  parentUrl: '/financialManage/riskOrderOK'
                },
                component: () => import('../pages/financialManage/riskOrderOK/riskOrderList.vue')
              }
            ]
          },
          {
            path: '/financialManage/basicLawSettlement',
            redirect: '/financialManage/basicLawSettlement',
            meta: {
              title: '人身个险结算'
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/financialManage/basicLawSettlement',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/financialManage/basicLawSettlement/index.vue')
              },
              {
                path: '/financialManage/basicLawSettlement/newReport',
                meta: {
                  title: '新建结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/basicLawSettlement'
                },
                component: () => import('../pages/financialManage/basicLawSettlement/detailStep')
              },
              {
                path: '/financialManage/basicLawSettlement/editReport',
                meta: {
                  title: '编辑结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/basicLawSettlement'
                },
                component: () => import('../pages/financialManage/basicLawSettlement/detailStep.vue')
              }
            ]
          },
          {
            path: '/financialManage/basicLawSettlement/detail',
            meta: {
              title: '结算详情',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/basicLawSettlement/detail.vue')
          },
          {
            path: '/financialManage/salesmanPaySettlement',
            meta: {
              title: '业务员综合薪酬'
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/financialManage/salesmanPaySettlement',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/financialManage/salesmanPaySettlement/index.vue')
              },
              {
                path: '/financialManage/salesmanPaySettlement/newReport',
                meta: {
                  title: '新建结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/salesmanPaySettlement'
                },
                component: () => import('../pages/financialManage/salesmanPaySettlement/detailStep')
              },
              {
                path: '/financialManage/salesmanPaySettlement/editReport',
                meta: {
                  title: '编辑结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/salesmanPaySettlement'
                },
                component: () => import('../pages/financialManage/salesmanPaySettlement/detailStep.vue')
              },
              {
                path: '/financialManage/salesmanPaySettlement/detail',
                meta: {
                  title: '明细',
                  parentUrl: '/financialManage/salesmanPaySettlement'
                },
                component: () => import('../pages/financialManage/salesmanPaySettlement/detail.vue')
              }
            ]
          },
          {
            path: '/financialManage/salesmanWithdrawal',
            name: 'financialManage.salesmanWithdrawal',
            meta: {
              title: '业务员提现',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/salesmanWithdrawal/index.vue')
          },
          {
            path: '/financialManage/groupFinanceSettlement',
            meta: {
              title: '团财基础费用结算'
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/financialManage/groupFinanceSettlement',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/financialManage/groupFinanceSettlement/index.vue')
              },
              {
                path: '/financialManage/groupFinanceSettlement/newReport',
                meta: {
                  title: '新建结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/groupFinanceSettlement'
                },
                component: () => import('../pages/financialManage/groupFinanceSettlement/detailStep')
              },
              {
                path: '/financialManage/groupFinanceSettlement/editReport',
                meta: {
                  title: '编辑结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/groupFinanceSettlement'
                },
                component: () => import('../pages/financialManage/groupFinanceSettlement/detailStep')
              },
              {
                path: '/financialManage/groupFinanceSettlement/detail',
                meta: {
                  title: '结算明细',
                  keepAlive: true,
                  parentUrl: '/financialManage/groupFinanceSettlement'
                },
                component: () => import('../pages/financialManage/groupFinanceSettlement/detail.vue')
              }
            ]
          },
          {
            path: '/financialManage/activitySettlement',
            meta: {
              title: '活动结算'
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/financialManage/activitySettlement',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/financialManage/activitySettlement/index.vue')
              },
              {
                path: '/financialManage/activitySettlement/newReport',
                meta: {
                  title: '新建结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/activitySettlement'
                },
                component: () => import('../pages/financialManage/activitySettlement/detailStep.vue')
              },
              {
                path: '/financialManage/activitySettlement/editReport',
                meta: {
                  title: '编辑结算报表',
                  keepAlive: true,
                  parentUrl: '/financialManage/activitySettlement'
                },
                component: () => import('../pages/financialManage/activitySettlement/detailStep')
              },
              {
                path: '/financialManage/activitySettlement/detail',
                meta: {
                  title: '保单详情',
                  keepAlive: true,
                  parentUrl: '/financialManage/activitySettlement'
                },
                component: () => import('../pages/financialManage/activitySettlement/detail.vue')
              }
            ]
          },
          {
            path: '/financialManage/commissionSettlementQuery',
            meta: {
              title: '业务员基础费用结算查询',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/commissionSettlementQuery/index.vue')
          }
        ]
      },
      {
        path: '/orgSettlement',
        meta: {
          title: '机构结算'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/orgSettlement/commissionSettlementQuery',
            meta: {
              title: '机构基础费用结算查询',
              keepAlive: true
            },
            component: () => import('../pages/financialManage/orgSettlement/commissionSettlementQuery/index.vue')
          },
          {
            path: '/orgSettlement/commissionSettlement',
            redirect: '/orgSettlement/commissionSettlement',
            meta: {
              title: '个险基础费用结算'
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/orgSettlement/commissionSettlement',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/financialManage/orgSettlement/commissionSettlement/index.vue')
              },
              {
                path: '/orgSettlement/commissionSettlement/newReport',
                meta: {
                  title: '新建结算单',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/commissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/commissionSettlement/detailStep')
              },
              {
                path: '/orgSettlement/commissionSettlement/editReport',
                meta: {
                  title: '编辑结算单',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/commissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/commissionSettlement/detailStep')
              },
              {
                path: '/orgSettlement/commissionSettlement/detail',
                meta: {
                  title: '明细',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/commissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/commissionSettlement/detail')
              },
              {
                path: '/orgSettlement/commissionSettlement/subordinateDetail',
                meta: {
                  title: '结算单详情',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/commissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/commissionSettlement/subordinateDetail')
              },
              {
                path: '/orgSettlement/commissionSettlement/subordinateBillDetail',
                meta: {
                  title: '账单明细',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/commissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/commissionSettlement/subordinateBillDetail')
              },
              {
                path: '/orgSettlement/commissionSettlement/subordinatePolicyDetails',
                meta: {
                  title: '保单明细',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/commissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/commissionSettlement/subordinatePolicyDetails')
              }
            ]
          },
          {
            path: '/orgSettlement/groupCommissionSettlement',
            redirect: '/orgSettlement/groupCommissionSettlement',
            meta: {
              title: '团财基础费用结算'
            },
            component: () => import('../pages/router.vue'),
            children: [
              {
                path: '/orgSettlement/groupCommissionSettlement',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/financialManage/orgSettlement/groupCommissionSettlement/index.vue')
              },
              {
                path: '/orgSettlement/groupCommissionSettlement/newReport',
                meta: {
                  title: '新建结算单',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/groupCommissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/groupCommissionSettlement/detailStep')
              },
              {
                path: '/orgSettlement/groupCommissionSettlement/editReport',
                meta: {
                  title: '编辑结算单',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/groupCommissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/groupCommissionSettlement/detailStep')
              },
              {
                path: '/orgSettlement/groupCommissionSettlement/detail',
                meta: {
                  title: '明细',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/groupCommissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/groupCommissionSettlement/detail')
              },
              {
                path: '/orgSettlement/groupCommissionSettlement/subordinateDetail',
                meta: {
                  title: '结算单详情',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/groupCommissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/groupCommissionSettlement/subordinateDetail')
              },
              {
                path: '/orgSettlement/groupCommissionSettlement/subordinateBillDetail',
                meta: {
                  title: '账单明细',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/groupCommissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/groupCommissionSettlement/subordinateBillDetail')
              },
              {
                path: '/orgSettlement/groupCommissionSettlement/subordinatePolicyDetails',
                meta: {
                  title: '保单明细',
                  keepAlive: true,
                  parentUrl: '/orgSettlement/groupCommissionSettlement'
                },
                component: () => import('../pages/financialManage/orgSettlement/groupCommissionSettlement/subordinatePolicyDetails')
              }
            ]
          }
        ]
      }
    ]
  },
  /*********平台结算**********/
  {
    path: '/settlement',
    redirect: '/settlementManage/financial',
    meta: {
      title: '平台结算'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/settlementManage',
        meta: {
          title: '个险结算'
        },
        component: () => import('../pages/router'),
        children: [
          {
            path: '/settlementManage/settleablePolicy',
            meta: {
              title: '可结算保单统计',
              keepAlive: true
            },
            component: () => import('../pages/settlementManage/settleablePolicy/index.vue')
          },
          {
            path: '/settlementManage/financial',
            meta: {
              title: '收入管理',
              keepAlive: true
            },
            component: () => import('../pages/settlementManage/financial/index.vue')
          },
          {
            path: '/settlementManage/financialRecord',
            meta: {
              title: '提现管理',
              keepAlive: true
            },
            component: () => import('../pages/settlementManage/financialRecord/index.vue')
          }
        ]
      },

      {
        path: '/settlementManage/groupSettlement',
        meta: {
          title: '团险结算'
        },
        component: () => import('../pages/settlementManage/groupSettlement')
      }
    ]
  },
  {
    path: '/insuranceSupervisionTable',
    redirect: '/financialManage/insuranceSupervisionTable',
    meta: {
      title: '监管报备'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/financialManage/insuranceSupervisionTable',
        meta: {
          title: '人身险报表'
        },
        component: () => import('../pages/financialManage/insuranceForms/lifeInsurance.vue')
      },
      {
        path: '/financialManage/insurancePropertyTable',
        meta: {
          title: '财产险报表'
        },
        component: () => import('../pages/financialManage/insuranceForms/insurancePropertyTable.vue')
      }
    ]
  },

  /* **************系统日志*************** */
  {
    path: '/systemSet',
    redirect: '/systemSet/accountManage',
    meta: {
      title: '系统日志'
    },
    component: () => import('../pages/systemSet/index'),
    children: [
      {
        path: '/systemSet/logManagement',
        component: () => import('../pages/systemSet/logManagement.vue'),
        meta: {
          title: '操作日志',
          keepAlive: true
        }
      },
      {
        path: '/systemSet/loginLogManagement',
        component: () => import('../pages/systemSet/loginLogManagement.vue'),
        meta: {
          title: '登录日志',
          keepAlive: true
        }
      }
    ]
  },
  // 运营中心
  {
    path: '/operate',
    redirect: '/operate/appConfig',
    meta: {
      title: '运营中心'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/operate/businessOperate',
        component: () => import('../pages/operate/businessOperate/index.vue'),
        meta: {
          title: '展业端运营',
          keepAlive: true
        }
      },
      {
        path: '/operate/myMicroshop',
        component: () => import('../pages/operate/myMicroshop/index.vue'),
        meta: {
          title: '微店审核'
        }
      },
      {
        path: '/operate/noticeManage',
        component: () => import('../pages/operate/noticeManage'),
        meta: {
          title: '公告管理',
          keepAlive: true
        }
      },
      {
        path: '/personnelMag/trainManage',
        meta: {
          title: '线下培训',
          keepAlive: true
        },
        component: () => import('../pages/personnelMag/trainManage/index.vue')
      }
    ]
  },
  // 个性化配置
  {
    path: '/configure',
    meta: {
      title: '个性化配置',
      keepAlive: true
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/systemSet/systemConfig',
        meta: {
          title: '系统配置项'
        },
        component: () => import('../pages/systemSet/systemConfig/index.vue')
      },
      {
        path: '/configure/onLineInduction',
        component: () => import('../pages/router'),
        children: [
          {
            path: '/operate/onLineInduction',
            component: () => import('../pages/operate/onLineInduction'),
            meta: {
              title: '在线入职配置',
              keepAlive: true
            }
          },
          {
            path: '/operate/onLineInduction/contractConfigList',
            component: () => import('../pages/operate/onLineInduction/contractConfigList.vue'),
            meta: {
              title: '合同列表',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/operate/appConfig',
        component: () => import('../pages/operate/appConfig/index'),
        meta: {
          title: '展业端配置'
        }
      },
      {
        path: '/orderManage/appointment',
        name: 'orderManage.appointment',
        redirect: '/orderManage/appointment/index',
        component: () => import('../pages/router.vue'),
        meta: {
          title: '预约顾问配置'
        },
        children: [
          {
            path: '/orderManage/appointment/index',
            name: 'orderManage.appointment.index',
            component: () => import('../pages/orderManage/appointment/index.vue')
          },
          {
            path: '/orderManage/appointment/formSet',
            name: 'orderManage.appointment.formSet',
            component: () => import('../pages/orderManage/appointment/formSet.vue'),
            meta: {
              title: '自定义设置'
            }
          }
        ]
      },
      {
        path: '/weChat/weChatAcc/index',
        name: 'weChatAcc',
        component: () => import('../pages/weChat/weChatAcc/index.vue'),
        meta: {
          title: '公众号管理',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/dataCenter',
    redirect: '/dataCenter/dataReport',
    meta: {
      title: '数据中心'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/dataCenter/dataReport',
        meta: {
          title: '数据报表'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/dataCenter/dataReport/rerformanceReport',
            meta: {
              title: '业绩报表',
              keepAlive: true
            },
            component: () => import('../pages/dataCenter/dataReport/rerformanceReport/index.vue')
          },
          {
            path: '/dataCenter/dataReport/businessSpeed',
            meta: {
              title: '业绩进度报表',
              keepAlive: true
            },
            component: () => import('../pages/dataCenter/dataReport/rerformanceReport/businessSpeed.vue')
          }
        ]
      },
      {
        path: '/dataCenter/trendAnalysis',
        meta: {
          title: '经营分析'
        },
        component: () => import('../pages/router.vue'),
        children: [
          {
            path: '/dataCenter/dataReport/productSales',
            meta: {
              title: '产品销售分布',
              keepAlive: true
            },
            component: () => import('../pages/dataCenter/dataReport/businessAnalysis/productSales/index.vue')
          },
          {
            path: '/dataCenter/dataReport/trendAnalysis',
            meta: {
              title: '业绩趋势分析',
              keepAlive: true
            },
            component: () => import('../pages/dataCenter/dataReport/businessAnalysis/trendAnalysis/index.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/workOrder',
    meta: {
      title: '工单管理'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/workOrder/claimManage',
        meta: {
          title: '理赔管理',
          keepAlive: true
        },
        component: () => import('../pages/workOrder/claimManage/index.vue')
      },
      {
        path: '/workOrder/paperPolicy',
        component: () => import('../pages/workOrder/paperPolicy/index.vue'),
        meta: {
          title: '纸质保单',
          keepAlive: true
        }
      }
    ]
  },
  /*********活动管理**********/
  {
    path: '/recruiting',
    redirect: '/activityManage/recruiting',
    meta: {
      title: '活动管理'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/activityManage/recruiting',
        redirect: '/activityManage/recruiting',
        component: () => import('../pages/activityManage/index.vue'),
        meta: {
          title: '活动管理'
        },
        children: [
          {
            path: '/activityManage/recruiting',
            component: () => import('../pages/activityManage/recruiting/index'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/activityManage/addActivity',
            component: () => import('../pages/activityManage/recruiting/addModal'),
            meta: {
              title: '新增活动',
              keepAlive: true,
              parentUrl: '/activityManage/recruiting'
            }
          },
          {
            path: '/activityManage/editActivity',
            component: () => import('../pages/activityManage/recruiting/addModal.vue'),
            meta: {
              title: '编辑活动',
              keepAlive: true,
              parentUrl: '/activityManage/recruiting'
            }
          }
        ]
      },
      {
        path: '/activityManage/activityAddress',
        component: () => import('../pages/activityManage/activityAddress/index'),
        meta: {
          title: '实物奖励',
          keepAlive: true
        }
      },
      {
        path: '/activityManage/zeroInsure',
        component: () => import('../pages/activityManage/zeroInsure/index.vue'),
        meta: {
          title: '赠险管理',
          keepAlive: true
        }
      }
    ]
  },

  {
    path: '/contentManagement',
    meta: {
      title: '内容管理'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/contentManagement/momentsAssistant',
        meta: {
          title: '朋友圈助手',
          keepAlive: true
        },
        component: () => import('../pages/contentManagement/index.vue'),
        children: [
          {
            path: '/contentManagement/momentsAssistant/material',
            meta: {
              title: '朋友圈素材',
              keepAlive: true
            },
            component: () => import('../pages/contentManagement/momentsAssistant/index.vue')
          },
          {
            path: '/contentManagement/circleClassification/circle',
            meta: {
              title: '朋友圈分类',
              keepAlive: true
            },
            component: () => import('../pages/contentManagement/circleClassification/index.vue')
          },
          {
            path: '/contentManagement/UserManagement/user',
            meta: {
              title: '发布用户管理',
              keepAlive: true
            },
            component: () => import('../pages/contentManagement/UserManagement/index.vue')
          }
        ]
      },
      {
        path: '/contentManagement/posterManagement',
        meta: {
          title: '海报管理',
          keepAlive: true
        },
        component: () => import('../pages/contentManagement/index.vue'),
        children: [
          {
            path: '/contentManagement/posterManagement',
            meta: {
              title: '海报管理',
              keepAlive: true
            },
            component: () => import('../pages/contentManagement/posterManagement/index.vue')
          }
        ]
      },
      {
        path: '/contentManagement/trainingCourse',
        meta: {
          title: '培训课程',
          keepAlive: true
        },
        component: () => import('../pages/contentManagement/index.vue'),
        children: [
          {
            path: '/trainingCourse/courseOnline',
            component: () => import('../pages/contentManagement/trainingCourse/courseOnline/index.vue'),
            meta: {
              title: '培训课程'
            }
          },
          {
            path: '/trainingCourse/coursePreview',
            component: () => import('../pages/contentManagement/trainingCourse/courseOnline/coursePreview.vue'),
            meta: {
              title: '课程预览'
            }
          },
          {
            path: '/trainingCourse/courseMenuNew',
            component: () => import('../pages/contentManagement/trainingCourse/courseMenuNew'),
            meta: {
              title: '课程分类'
            }
          },
          {
            path: '/trainingCourse/courseRecord',
            component: () => import('../pages/contentManagement/trainingCourse/courseRecord'),
            meta: {
              title: '人员培训记录'
            }
          }
        ]
      },
      {
        path: '/contentManagement/testCenter',
        meta: {
          title: '考试中心'
        },
        component: () => import('../pages/contentManagement/index.vue'),
        children: [
          {
            path: '/testCenter/testMenu',
            component: () => import('../pages/contentManagement/testCenter/testMenu'),
            meta: {
              title: '考试分类',
              keepAlive: true
            }
          },
          {
            path: '/testCenter/testCenter',
            component: () => import('../pages/contentManagement/testCenter/testCenter'),
            meta: {
              title: '考试中心',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/contentManagement/articleManagement',
        meta: {
          title: '文章管理',
          keepAlive: true
        },
        component: () => import('../pages/contentManagement/index.vue'),
        children: [
          {
            path: '/contentManagement/articleManagement',
            redirect: '/contentManagement/articleManagement',
            meta: {
              title: '文章素材'
            },
            component: () => import('../pages/contentManagement/index.vue'),
            children: [
              {
                path: '/contentManagement/articleManagement',
                meta: {
                  keepAlive: true
                },
                component: () => import('../pages/contentManagement/articleManagement/index.vue')
              },
              {
                path: '/contentManagement/articleManagement/articleDetail',
                meta: {
                  title: '文章管理',
                  keepAlive: true,
                  parentUrl: '/contentManagement/articleManagement'
                },
                component: () => import('../pages/contentManagement/articleManagement/articleDetail.vue')
              }
            ]
          },
          {
            path: '/contentManagement/articleManagement/articleMenu',
            meta: {
              title: '文章分类',
              keepAlive: true
            },
            component: () => import('../pages/contentManagement/articleManagement/articleMenu/index.vue')
          }
        ]
      },
      {
        path: '/contentManagement/publicMaterialLibrary',
        redirect: '/contentManagement/publicMaterialLibrary',
        meta: {
          title: '公共素材库',
          keepAlive: true
        },
        component: () => import('../pages/contentManagement/index.vue'),
        children: [
          {
            path: '/contentManagement/publicMaterialLibrary',
            meta: {
              keepAlive: true
            },
            component: () => import('../pages/contentManagement/publicMaterialLibrary/index.vue')
          },
          {
            path: '/contentManagement/articleManagement/videoListDetail',
            meta: {
              title: '系列视频',
              parentUrl: '/contentManagement/publicMaterialLibrary'
            },
            component: () => import('../pages/contentManagement/publicMaterialLibrary/videoListDetail.vue')
          }
        ]
      },
      {
        path: '/contentManagement/articleMaterialsDetail',
        meta: {
          title: '文章导入',
          keepAlive: true
        },
        component: () => import('../pages/contentManagement/publicMaterialLibrary/components/articleMaterialsDetail.vue')
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

let modalHistoryList = [];
router.afterEach((to, from) => {
  const list = [];
  console.log('to', to);
  modalHistoryList.forEach((item, i) => {
    if (to.fullPath == item.url) {
      item.vueObj.visible = true;
    } else {
      list.push(item);
    }
  });
  modalHistoryList = list;
  // 根据 缓存 设置scrollTop
  const pageScrollInfo = sessionStorage.pageScrollInfo ? JSON.parse(sessionStorage.pageScrollInfo) : {};
  const scrollTop = pageScrollInfo[to.fullPath];
  delete pageScrollInfo[to.fullPath];
  sessionStorage.pageScrollInfo = JSON.stringify(pageScrollInfo);
  window.setTimeout(() => {
    document.documentElement.scrollTop = scrollTop || 0;
  }, 100);
});
router.beforeEach((to, from, next) => {
  // 记录当前页面滚动条位置
  let pageScrollInfo = sessionStorage.pageScrollInfo ? JSON.parse(sessionStorage.pageScrollInfo) : {};
  pageScrollInfo[from.fullPath] = document.documentElement.scrollTop;
  sessionStorage.pageScrollInfo = JSON.stringify(pageScrollInfo);
  // 隐藏所有弹窗
  document.querySelectorAll('.ivu-modal-wrap').forEach(item => {
    saveModalHistory(from, item.parentNode.__vue__);
    item.parentNode.__vue__ && item.parentNode.__vue__.close && item.parentNode.__vue__.close();
  });
  // 抽屉
  document.querySelectorAll('.ivu-drawer-wrap').forEach(item => {
    saveModalHistory(from, item.parentNode.__vue__);
    item.parentNode.__vue__ && item.parentNode.__vue__.close && item.parentNode.__vue__.close();
  });
  // 下拉select
  document.querySelectorAll('.ivu-select').forEach(item => {
    item.__vue__ && item.__vue__.hideMenu && item.__vue__.hideMenu();
  });
  // 日期组件
  document.querySelectorAll('.ivu-date-picker').forEach(item => {
    item.__vue__.visible = false;
  });
  let hasLogin = localStorage.getItem('hasLogin');
  const loginPage = ['login', 'web.login', 'insteadTbLogin', 'loginExamine'];
  document.title = config.appFullName;
  if (loginPage.includes(to.name)) {
    if (hasLogin) {
      next('/');
    } else {
      next();
    }
  } else {
    if (!hasLogin) {
      units.goLogin();
    } else {
      const url = to.path;
      if (url && url != '/' && url != '/home' && url != '/empty') {
        const arr = [];
        to.matched.forEach(item => {
          if (item.meta.title && item.meta.title != '首页') {
            arr.push({
              name: item.meta.title,
              path: item.path,
              noclick: item.path ? false : true
            });
          }
        });
        window.parent.postMessage(
          {
            updateNav: url,
            appMessage: true,
            nav: arr,
            parentUrl: to.meta.parentUrl ? to.meta.parentUrl : undefined
          },
          '*'
        );
        // tag消息
        const matched = to.matched.filter(item => {
          return !!item.meta.title;
        });
        window.parent.postMessage(
          {
            webChange: {
              path: to.path,
              fullPath: to.fullPath,
              title: matched.length ? matched[matched.length - 1].meta.title : '',
              parentUrl: to.meta.parentUrl ? to.meta.parentUrl : undefined
            },
            appMessage: true
          },
          '*'
        );
      }
      try {
        next();
      } catch (error) {
        console.log('next.onError', error);
        window.setTimeout(() => {
          location.replace(url);
        }, 5000);
      }
    }
  }
});
// 处理发版导致的缓存报错
router.onError(error => {
  // const isError = error.message.includes("Cannot read properties")||error.message.includes("Loading chunk")
  const isError = error.message;
  const targetPath = router.history.pending.fullPath;
  console.log('router.onError', targetPath, error);
  if (isError) {
    let url = targetPath;
    if (url.includes('?')) {
      url += '&t=' + Date.now();
    } else {
      url += '?t=' + Date.now();
    }
    window.setTimeout(() => {
      location.replace(url);
    }, 5000);
  }
});
export default router;

// 缓存切换路由时关闭的弹窗
function saveModalHistory(from, vueObj) {
  if (!vueObj) {
    return;
  }
  if (vueObj.visible) {
    if (vueObj.$parent.visible) {
      modalHistoryList.push({
        url: from.fullPath,
        vueObj: vueObj.$parent
      });
    } else {
      modalHistoryList.push({
        url: from.fullPath,
        vueObj: vueObj
      });
    }
  }
}
